
import { BreadCrumbs } from "../shared/breadCrumbs/BreadCrumbs";
import { TopBar } from "../shared/topBar/TopBar";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { SBADropDown } from "../UiComponents/SBADropDown";
import { UrlPath } from "../../config/routeConfig";
import { GetUserDetails } from '../actions/userProfileAction';
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";

export const Profile = () => {
    let Level = [{ BreadCrumb: "Home > Profile", Routes: "/Home" }];  
    const dispatch = useDispatch();
    const AuthorizationToken=sessionStorage.getItem('entryKey');
    useEffect(() => {   
        dispatch(GetUserDetails(AuthorizationToken));     
    }, []);
    const Userdetails = useSelector(state => {
        return state.userDetails.userDetails
    }) || [];
    const Gstate = useSelector(state => state) || {};
    const currentUser= Gstate.common.userDetails;
  return( <>
      <div>
          <TopBar label={"Account Setting"} />
          <BreadCrumbs Levels={Level} />
          <div id="content" className="home-profile-screen">
              <div className="p-4">
          <Tabs
             // defaultActiveKey={}
              id="uncontrolled-tab-example"
              className="ms-3"
          >
                      <Tab eventKey="Basic" title="Basic">
                          <div className="tab">
                          <div className="tab-content" id="myTabContent">
                              <div className="tab-pane fade show active" id="home-tab-pane" role="tabpanel"
                                  aria-labelledby="home-tab" tabindex="0">
                                  <div className="p-border rounded ">
                                      <div className="p-3 bg-white s-border-bottom rounded-top">
                                          <div className="row ">
                                              <div className="col-md-3 mb-4">
                                                  <div>
                                                          <label className="label">First Name<span className="mandatory">*</span></label>
                                                          <input
                                                              className="form-control w-100"
                                                              type="text"
                                                              Value={currentUser.FirstName}
                                                              //onChange={}
                                                              required
                                                          />
                                            </div>
                                                  </div>
                                              <div className="col-md-3 mb-4">
                                                      <label className="label">Middle Name</label>
                                                      <input
                                                          className="form-control w-100"
                                                          type="text"
                                                          
                                                          //onChange={}
                                                          required
                                                      />
                                                      </div>
                                              <div className="col-md-3 mb-4">
                                                          <div>
                                                          <label className="label">Last Name <span className="mandatory">*</span></label>
                                                          <input
                                                              className="form-control w-100"
                                                              type="text"
                                                              Value={currentUser.LastName}
                                                              //onChange={}
                                                            
                                                          />
                                            </div>
                                                          </div>
                                              <div className="col-md-3 mb-4">
                                                              <div>
                                                          <label className="label">Birthday	</label>
                                                          <div>
                                                              <DatePicker className="w-80" id="txtbirthday">
                                                              </DatePicker>
                                                          </div>
                                            </div>
                                                              </div>
                                              <div className="col-md-3 mb-4">
                                                                  <div>
                                                      <label for="select fund" className="mb-1 label fs-12">Job
                                                    Role</label>
                                                          <SBADropDown
                                                              className='w-100'
                                                              textField={""}
                                                              valueField={""}
                                                              //data={}
                                                             // onChange={}
                                                          />
                                                                  </div>
                                                              </div>
                                              <div className="col-md-3 mb-4">
                                                                  <div>
                                                      <label for="select fund" className="mb-1 label fs-12">Business Extension
                                                    1</label>
                                                          <SBADropDown
                                                              className='w-100'
                                                              textField={""}
                                                              valueField={""}
                                                              //data={}
                                                              //onChange={}
                                                          />
                                                                  </div>
                                                              </div>
                                              <div className="col-md-3 mb-4">
                                                                  <div>
                                                          <label className="label">Phone No.</label>
                                                          <input
                                                              className="form-control w-100"
                                                              type="text"
                                                              //onChange={}
                                                             
                                                          />
                                            </div>
                                                                  </div>
                                              <div className="col-md-3 mb-4">
                                                                      <div>
                                                      
                                                          <label className="label">Business Email</label>
                                                          <input
                                                              className="form-control w-100"
                                                              type="text"
                                                              Value={currentUser.Email}
                                                              //onChange={}
                                                              disabled 
                                                          />
                                            </div>
                                                                      </div>
                                              <div className="col-md-3 mb-4">
                                                                          <div>
                                                      <label for="select fund" className="mb-1 label">Date of Joining</label>
                                                          <DatePicker className="w-80" id="txtdateofjoining">
                                                          </DatePicker>
                                            </div>
                                                                          </div>
                                             
                                                                      </div>
                                                                  </div>
                                      
                                                                      </div>
                                                                  </div>
                          </div>
                          

                          </div>
                          
                          <div className="p-3 bg-white s-border-bottom rounded-top">
                              <div className="d-flex justify-content-end gap-3">
                          <button className="s-sm-btn">Cancel</button>
                          <button className="p-sm-btn">Next</button>
                      </div>
                          </div>
            

              </Tab>
                      <Tab eventKey="Preferences" title="Preferences">
                          <div className="p-3 bg-white life-science rounded">
                     
                  </div>
              </Tab>
              
          </Tabs>

          </div>
          </div>
      </div>
  </>
  )
};
 